import { createFrozenSelector } from './createFrozenSelector';
export const createTypedFrozenSelector = createFrozenSelector;